import * as React from 'react';
import classNames from 'classnames';
import './checkBox.module.scss';

export const CheckBox = ({ selected, className = undefined, styleName = undefined }) => (
    <div styleName={classNames('check-box', { selected: selected })} className={className}>
        {selected && <div styleName="check-box-inner" />}
    </div>
);
